export const apiUrl = process.env.REACT_APP_API_URL;
export const authURL =
  'https://auth.geowellex.com/auth/realms/Geowellex/protocol/openid-connect';
